import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/remote-config";
import Product from "./Product";
import { ProductCarousel } from "./ProductCarousel";

export default function ProductCarouselContainer() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const remoteConfig = firebase.remoteConfig();
        // Fetcht alle 10 min
        remoteConfig.settings.minimumFetchIntervalMillis = 1000 * 60 * 10;
        await remoteConfig.fetchAndActivate();
        remoteConfig.defaultConfig = {
            ProductCarousel: '["20167", "13510"]',
            harmonieharfe25saiten: '["13445","14672","20167","13510","23003"]',
            veehharfe25saiten: '["13445","14672","20167","13510","19758"]',
            veehharfe18saiten: '["15170","21295","20167","14623"]',
            veehharfe37saiten: '["3029","13445","20167","13510","22505"]',
            zauberharfe25saitenSopranAlt:
                '["13445","14672","20167","13510","19758"]',
            zauberharfe25saitenBass: '["15037","21295","20167","13510"]',
            zauberharfe21saitenSopranAlt: '["3041","21295","20167"]',
            akkordzither25saiten: '["22565","6574","7551"]',
        };
        let key = localStorage.getItem("InstrumentKey") || "ProductCarousel";

        const val = remoteConfig.getValue(key);
        console.log(key, val);
        setData(JSON.parse(val._value));
        setLoading(false);
    };

    return (
        <div>
            {!loading && (
                <div>
                    <ProductCarousel data={data} />
                </div>
            )}
        </div>
    );
}
